module.exports = __webpack_public_path__ + "img/close-circle.c583fe52.svg";